import { lazyGetServerOptionsForFeature } from 'owa-outlook-service-options';
import { LgpdAdsOptions, lgpdAdsOwsOptionsFeatureType } from 'owa-ads-ows-options';

export default async function loadLgpdoptInBit(): Promise<number> {
    const getServerOptionsForFeature = await lazyGetServerOptionsForFeature.import();

    const response = await getServerOptionsForFeature<LgpdAdsOptions>(lgpdAdsOwsOptionsFeatureType);

    if (response == null || response.optInBit == null) {
        return 0;
    }

    return response.optInBit;
}
